import React, {Component, useState, useEffect} from 'react'
import {BrowserRouter as Router, Switch, Route, withRouter} from 'react-router-dom'
import {
    MDBContainer, MDBRow, MDBCol
} from 'mdbreact';
import Heading from "../Heading/Heading";
import Homepage from "../Homepage/Homepage";
import LeftNavBar from "../LeftNavBar/LeftNavBar"
import LoginPage from "../LoginPage/LoginPage";
import AdminLayout from '../AdminLayout/AdminLayout'

import {useTranslation} from "react-i18next";
import firebase from "firebase";
import classes from './RouterManager.module.css'
import {connect} from "react-redux";

import {supportedLanguages} from "../../Assets/i18n/i18n";
import ListCategory from "../ListCategory/ListCategory";
import BottomAppBar from "../BottomAppBar/BottomAppBar";
import ListTips from "../ListTips/ListTips";
import CategoryPage from "../CategoryPage/CategoryPage";
import SearchPage from "../SearchPage/SearchPage";
import About from "../About/About";
import ModalController from "../../Component/Modal/ModalController";
import ReportModal from "../../Component/Modal/ReportModal/ReportModal";
import Newest from "../Newest/Newest";


const AdminOnly = (ComposedComponent, auth) => {

    const AdminOnlyClass = (props) => {
        const [isPass, setIsPass] = useState(false)

        useEffect(() => {
            if (!auth.isEmpty) {
                firebase.auth().currentUser.getIdTokenResult()
                    .then((idTokenResult) => {
                        if (idTokenResult.claims.type === "administrator") {
                            setIsPass(true)
                        }
                    })
            } else {
                setIsPass(false)
            }
        },[auth])

        if (isPass) {
            return <ComposedComponent location={props.location} history={props.history}
                                      auth={props.auth}/>
        } else {
            return (
                <div>
                    Checking...
                </div>
            )
        }

    }
    return AdminOnlyClass


}

const RouterManager = (props) => {
    const {t, i18n} = useTranslation()
    useEffect(() => {
        console.log(props)
    }, [props.isModalOpen])

    useEffect(() => {
        document.getElementById('publicloading').style.display = 'none'
        if (props.location.search !== '') {
            const searchParams = new URLSearchParams(props.location.search)

            if (searchParams.has('lang') && supportedLanguages.includes(searchParams.get('lang')) &&
                localStorage.getItem('i18n-lang') !== searchParams.get('lang')
            ) {
                i18n.changeLanguage(searchParams.get('lang'))
                localStorage.setItem('i18n-lang', searchParams.get('lang'));
            }

        }
    }, [])

    return (
        <MDBContainer fluid={true} className={classes.RouterManger}>
            <ModalController
                history={props.history}
            />

            <MDBRow>
                <MDBCol xl="2" lg="3" md="12" sm="12" xs="12"
                        className={[classes.RemovePadding, classes.LeftCol].join(' ')}>
                    <LeftNavBar/>
                </MDBCol>

                <MDBCol xl="10" lg="9" md="12" sm="12" xs="12" className={classes.RemovePadding}>
                    <Route path="/">
                        <Heading/>
                    </Route>
                    <div className={classes.BottomButtonList}>
                        <Route path={"/"}>
                            <BottomAppBar/>
                        </Route>
                    </div>

                    <div className={classes.MainContainer} id={'mainContainer'}>
                        <Switch>
                            <Route path="/login" exact>
                                <LoginPage/>
                            </Route>
                            <Route path="/p:id" exact>
                                {/*<MemberLayout/>*/}
                            </Route>
                            <Route path="/g:id" exact>
                                {/*<MemberLayout/>*/}
                            </Route>
                            <Route path="/c/:id" exact>
                                <CategoryPage/>
                            </Route>
                            <Route path="/admin" component={AdminOnly(AdminLayout, props.auth)}>
                            </Route>
                            <Route path="/tips" exact>
                                <ListTips/>
                            </Route>
                            <Route path="/list" exact>
                                <ListCategory/>
                            </Route>
                            <Route path="/search">
                                <SearchPage/>
                            </Route>
                            <Route path="/about">
                                <About/>
                            </Route>
                            <Route path="/newest">
                                <Newest/>
                            </Route>
                            <Route path="/">
                                <Homepage/>
                            </Route>
                        </Switch>
                    </div>

                </MDBCol>

            </MDBRow>
        </MDBContainer>
    )
}



const mapStateToProps = state => {
    return {
        auth: state.firebase.auth
    }

}

const enhance = connect(
    mapStateToProps,
)

export default enhance(withRouter(RouterManager))